import { IncomingMessage, ServerResponse } from 'http';
import { LoginWithBookingDetailsFormValues } from '../components/Form/LoginForm/LoginWithBookingDetailsFormSchema';
import { Cookies } from './cookies';

const loginAtBranchCookieName = 'self-service-branch-login';
const loginWithBookingDetailsCookieName = 'self-service-login-details';

export class LoginCookieHandler {
    static setLoginAtBranchCode(value: string, context?: { req?: IncomingMessage; res?: ServerResponse }) {
        Cookies.getInstance(context).set({
            name: loginAtBranchCookieName,
            value: value,
        });
    }

    static clearLoginAtBranchCode(context?: { req?: IncomingMessage; res?: ServerResponse }) {
        Cookies.getInstance(context).remove(loginAtBranchCookieName);
    }

    static getLoginAtBranchCode(context?: { req?: IncomingMessage; res?: ServerResponse }): string | undefined {
        return (Cookies.getInstance(context).get(loginAtBranchCookieName) as string) || undefined;
    }

    static setLoginWithBookingDetails(value: LoginWithBookingDetailsFormValues, context?: { req?: IncomingMessage; res?: ServerResponse }) {
        const serializedValue = JSON.stringify(value);
        Cookies.getInstance(context).set({
            name: loginWithBookingDetailsCookieName,
            value: serializedValue,
        });
    }

    static getLoginWithBookingDetails(context?: { req?: IncomingMessage; res?: ServerResponse }): LoginWithBookingDetailsFormValues | null {
        const cookieValue = Cookies.getInstance(context).get(loginWithBookingDetailsCookieName) as string;
        return cookieValue?.[0] === '{' ? (JSON.parse(cookieValue) as LoginWithBookingDetailsFormValues) : null;
    }

    static clearLoginWithBookingDetails(context?: { req?: IncomingMessage; res?: ServerResponse }) {
        Cookies.getInstance(context).remove(loginWithBookingDetailsCookieName);
    }
}
